<template>
    <div>
        <card-header title="Edit Course" icon="fa-pencil"/>

        <card-body>
            <course-form :course="course" :card="card" :child="child"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteCourse"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Course?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!course.title"
                    >
                        <i class="fas fa-check mr-2"></i>Save Course
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";

    import CourseForm from "@/cards/courses/CourseForm";

    import {client as http} from '../../http_client';

    export default {
        components: {SeparatorListItem, SubheaderListItem, CardListItem, CourseForm, NavigationListItem, CardList, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props', 'child'],
        data() {
            return {
                course: {outline: []},
                confirmDelete: false,
                dirty: null,
            };
        },
        methods: {
            loadCourse: function(force) {
                this.$emit('loading', true);
                http.get('courses/new/' + this.props.courseId, {force}).then(response => { // TODO: temporary endpoint
                    if (!response.data.outline) response.data.outline = []; //TODO temp
                    this.course = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            submit: function() {
                this.$emit('loading', true);
                let payload = {
                    id: this.course.id,
                    title: this.course.title,
                    description: this.course.description,
                    code: this.course.code,
                    welcome: this.course.welcome,
                    logo: this.course.logo,
                    logo_white: this.course.logo_white,
                    active: this.course.active,
                    is_hidden: this.course.is_hidden,
                    allow_repeat_enrollment: this.course.allow_repeat_enrollment,
                    // Repeat-enrollment limits: blank inputs come through as
                    // '' — store NULL (unlimited / lifetime window)
                    max_enrollments: this.course.max_enrollments || null,
                    enrollment_window_years: this.course.enrollment_window_years || null,
                    show_titles: this.course.show_titles,
                    show_timer: this.course.show_timer,
                    show_welcome: this.course.show_welcome,
                    test_mode: this.course.test_mode,
                    content_framed: this.course.content_framed,
                    // Self-directed course fields
                    type: this.course.type || 'guided',
                    self_directed_config: this.course.self_directed_config || null
                };

                http.put('courses/' + this.props.courseId, payload, {force: true}).then(response => {
                    this.$reloadCard('courses');
                    this.$reloadCard('course', {courseId: this.props.courseId});
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {

                });
            },
            deleteCourse() {
                if (this.confirmDelete) {
                    this.$emit('loading', true);
                    http.delete('courses/' + this.props.courseId).then(response => {
                        this.$reloadCard('courses');
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    }).catch(err => {

                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            },
            reload() {
                this.loadCourse(true);
            }
        },
        watch: {
            'props.courseId': function() {
                this.dirty = null;
                this.loadCourse();
            },
            'course': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this course? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadCourse();
        }
    };
</script>
